import React from 'react';
import './boxInputFull.scss';

export default props => (
    <div className='boxInputFull'>{props.children}</div>
)
